interface Message {
  id: number;
  sender_type: 'user' | 'bot';
  message: string;
  timestamp_msk: string;
  template_key?: string;
  template_params?: string;
  message_type?: string;
}

interface MessageGroup {
  date: string;
  messages: Message[];
}

export const groupMessagesByDate = (messages: Message[]): MessageGroup[] => {
  const groups: { [key: string]: Message[] } = {};
  
  messages.forEach(message => {
    // Конвертируем московский timestamp в локальную дату пользователя
    // timestamp_msk формат: "YYYY-MM-DD HH:MM:SS"
    const [datePart, timePart] = message.timestamp_msk.split(' ');
    const [y, m, d] = datePart.split('-').map(s => parseInt(s, 10));
    const [hh, mm, ss] = timePart.split(':').map(s => parseInt(s, 10));
    // Переводим МСК (+03:00) в UTC
    const utcDate = new Date(Date.UTC(y, (m - 1), d, hh - 3, mm, ss));
    // Берём локальную календарную дату пользователя (YYYY-MM-DD)
    const localYear = utcDate.getFullYear();
    const localMonth = String(utcDate.getMonth() + 1).padStart(2, '0');
    const localDay = String(utcDate.getDate()).padStart(2, '0');
    const localDateKey = `${localYear}-${localMonth}-${localDay}`;
    
    if (!groups[localDateKey]) {
      groups[localDateKey] = [];
    }
    groups[localDateKey].push(message);
  });
  
  // Преобразуем в массив и сортируем по дате (новые даты внизу)
  return Object.keys(groups)
    .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
    .map(date => ({
      date,
      messages: groups[date]
    }));
}; 